'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GroupSetContainer = undefined;

var _arrayDifference = require('d2-utilizr/lib/arrayDifference');

var _arrayDifference2 = _interopRequireDefault(_arrayDifference);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _containerConfig = require('./containerConfig');

var _containerConfig2 = _interopRequireDefault(_containerConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupSetContainer = exports.GroupSetContainer = undefined;

exports.GroupSetContainer = GroupSetContainer = function GroupSetContainer(refs) {
    var api = refs.api,
        appManager = refs.appManager;


    var defaultPageSize = 100;

    Ext.define('Ext.ux.container.GroupSetContainer', {
        extend: 'Ext.container.Container',
        alias: 'widget.groupsetcontainer',
        cls: 'ns-dxselector',
        layout: 'column',
        bodyStyle: 'border:0 none',
        style: 'margin: ' + _containerConfig2.default.margin,
        getRecord: function getRecord() {
            var items = this.valueCmp.getValue(),
                record = {
                dimension: this.dataElement.id,
                name: this.dataElement.name
            };

            // array or object
            for (var i = 0; i < items.length; i++) {
                if ((0, _isObject2.default)(items[i])) {
                    items[i] = items[i].code;
                }
            }

            if (items.length) {
                record.filter = 'IN:' + items.join(';');
            }

            return record;
        },
        setRecord: function setRecord(record) {
            if ((0, _isString2.default)(record.filter) && record.filter.length) {
                var a = record.filter.split(':');
                this.valueCmp.setOptionValues(a[1].split(';'));
            }
        },
        getOptionSetOptions: function getOptionSetOptions(optionSetId, filters, limit, callbackFn) {
            var params = ['filter=optionSet.id:eq:' + optionSetId, 'fields=code,name'];

            if (limit) {
                params.push('pageSize=' + defaultPageSize);
            }

            if (filters) {
                filters.forEach(function (filter) {
                    return params.push('filter=' + filter);
                });
            }

            new api.Request(refs, {
                baseUrl: appManager.getApiPath() + '/options.json',
                params: params,
                success: callbackFn
            }).run();
        },
        initComponent: function initComponent() {
            var container = this,
                idProperty = 'code',
                nameProperty = 'name';

            this.nameCmp = Ext.create('Ext.form.Label', {
                text: this.dataElement.name,
                flex: 1,
                style: 'padding:' + _containerConfig2.default.namePadding
            });

            this.addCmp = Ext.create('Ext.button.Button', {
                cls: 'ns-linkbutton',
                style: 'padding: 0',
                height: 18,
                text: 'Duplicate',
                handler: function handler() {
                    container.duplicateDataElement();
                }
            });

            this.removeCmp = Ext.create('Ext.button.Button', {
                cls: 'ns-linkbutton',
                style: _containerConfig2.default.removeCmpStyle,
                height: 18,
                text: 'Remove',
                handler: function handler() {
                    container.removeDataElement();
                }
            });

            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
                valueField: 'id',
                displayField: 'name',
                queryMode: 'local',
                editable: false,
                style: 'margin-bottom:0',
                width: _containerConfig2.default.operatorCmpWidth,
                value: 'IN',
                store: {
                    fields: ['id', 'name'],
                    data: [{ id: 'IN', name: 'One of' }]
                }
            });

            this.searchStore = Ext.create('Ext.data.Store', {
                fields: [idProperty, nameProperty],
                data: [],
                loadOptionSet: function loadOptionSet(optionSetId, filters, pageSize) {
                    var store = this;

                    optionSetId = optionSetId || container.dataElement.optionSet.id;
                    pageSize = pageSize || defaultPageSize;

                    container.getOptionSetOptions(optionSetId, filters, true, function (_ref) {
                        var options = _ref.options;

                        if ((0, _isArray2.default)(options) && options.length) {
                            store.loadData(options.slice(0, pageSize));
                        }
                    });
                },
                listeners: {
                    datachanged: function datachanged(s) {
                        if (container.searchCmp && s.getRange().length) {
                            container.searchCmp.expand();
                        }
                    }
                }
            });

            // function
            this.filterSearchStore = function () {
                var selected = container.valueCmp.getValue();

                container.searchStore.clearFilter();

                container.searchStore.filterBy(function (record) {
                    return !(0, _arrayContains2.default)(selected, record.data[idProperty]);
                });
            };

            this.searchCmp = Ext.create('Ext.form.field.ComboBox', {
                multiSelect: true,
                width: _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.triggerCmpWidth,
                style: 'margin-bottom:0',
                emptyText: 'Search..',
                valueField: idProperty,
                displayField: nameProperty,
                hideTrigger: true,
                enableKeyEvents: true,
                queryMode: 'local',
                lastQuery: '',
                listConfig: {
                    minWidth: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth
                },
                store: this.searchStore,
                listeners: {
                    keyup: function keyup() {
                        var value = this.getValue(),
                            optionSetId = container.dataElement.optionSet.id;

                        // search
                        container.searchStore.loadOptionSet(optionSetId, ['name:ilike:' + value]);

                        // trigger
                        if (!value || (0, _isString2.default)(value) && value.length === 1) {
                            container.triggerCmp.setDisabled(!!value);
                        }
                    },
                    select: function select() {
                        var id = (0, _arrayFrom2.default)(this.getValue())[0];

                        // value
                        if (container.valueStore.findExact(idProperty, id) === -1) {
                            container.valueStore.add(container.searchStore.getAt(container.searchStore.findExact(idProperty, id)).data);
                        }

                        // search
                        this.select([]);

                        // filter
                        container.filterSearchStore();

                        // trigger
                        container.triggerCmp.enable();
                    },
                    expand: function expand() {
                        container.filterSearchStore();
                    }
                }
            });

            this.triggerCmp = Ext.create('Ext.button.Button', {
                cls: 'ns-button-combotrigger',
                disabledCls: 'ns-button-combotrigger-disabled',
                width: _containerConfig2.default.triggerCmpWidth,
                height: 22,
                handler: function handler(b) {
                    container.searchStore.loadOptionSet();
                }
            });

            this.valueStore = Ext.create('Ext.data.Store', {
                fields: [idProperty, nameProperty],
                listeners: {
                    add: function add() {
                        container.valueCmp.select(this.getRange());
                    },
                    remove: function remove() {
                        container.valueCmp.select(this.getRange());
                    }
                }
            });

            this.valueCmp = Ext.create('Ext.form.field.ComboBox', {
                multiSelect: true,
                style: 'margin-bottom:0',
                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.operatorCmpWidth,
                valueField: idProperty,
                displayField: nameProperty,
                emptyText: 'No selected items',
                editable: false,
                hideTrigger: true,
                store: container.valueStore,
                queryMode: 'local',
                listConfig: {
                    minWidth: 266,
                    cls: 'ns-optionselector'
                },
                setOptionValues: function setOptionValues(codeArray) {
                    var me = this,
                        records = [];

                    var filter = 'code:in:[' + codeArray.join(',') + ']';

                    container.getOptionSetOptions(container.dataElement.optionSet.id, [filter], false, // no limit
                    function (_ref2) {
                        var options = _ref2.options;

                        if ((0, _isArray2.default)(options) && options.length) {
                            container.valueStore.loadData(options);

                            me.setValue(options);
                        }
                    });
                },
                listeners: {
                    change: function change(cmp, newVal, oldVal) {
                        newVal = (0, _arrayFrom2.default)(newVal);
                        oldVal = (0, _arrayFrom2.default)(oldVal);

                        if (newVal.length < oldVal.length) {
                            var id = (0, _arrayDifference2.default)(oldVal, newVal)[0];
                            container.valueStore.removeAt(container.valueStore.findExact(idProperty, id));
                        }
                    }
                }
            });

            this.items = [{
                xtype: 'container',
                layout: 'hbox',
                width: _containerConfig2.default.nameCmpWidth,
                items: [this.nameCmp,
                //this.addCmp,
                this.removeCmp]
            }, this.operatorCmp, this.searchCmp, this.triggerCmp, this.valueCmp];

            this.self.superclass.initComponent.call(this);
        }
    });
};
//# sourceMappingURL=GroupSetContainer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ux/GroupSetContainer.js
 ** module id = 185
 ** module chunks = 0 1
 **/